import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  cardHeader: {
    background: '#F6F6F9',
    padding: '20px 32px',
    fontSize: '16px',
    fontWeight: 600,
    color: '#32324D',
    borderBottom: '1px solid #EAEAEF',
    '& .MuiCardHeader-action': {
      margin: 0
    }
  },
  CardContent: {
    color: '#32324D',
    '& .MuiInputBase-input': {
      color: '#32324D'
    }
  },
  productImage: {
    padding: '25px',
    width: '100%',
    maxHeight: '400px',
    objectFit: 'contain',
    borderRadius: '4px'
  },
  tableContainer: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    '& .MuiTableCell-head': {
      fontWeight: 700,
      fontSize: '12px',
      letterSpacing: '0.25px',
      textTransform: 'uppercase',
      color: '#434343',
      padding: '0 12px 4px'
    },
    '& .MuiTableCell-root': {
      padding: '12px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  },
  tableTitle: {
    fontWeight: 700,
    fontSize: '16px',
    letterSpacing: '0.15px',
    textTransform: 'uppercase',
    color: '#4B6FC2',
    padding: '12px'
  },
  autocomplete: {
    margin: '20px 0',
    width: '100%',
    maxWidth: '600px',
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
      transform: 'translate(14px, 20px) scale(1)'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)'
    }
  },
  chip: {
    background: '#F0F0FF',
    padding: '14px 2px',
    marginRight: '5px',
    marginBottom: '5px'
  },
  textField: {
    height: '40px',
    borderRadius: '4px',
    background: 'rgba(0, 0, 0, 0.04)'
  }
}));

export default useStyles;
